import { FC } from 'react'
import { Player } from '../../..'
import { useAppSelector } from '../../../../redux'
import { StyledCoursePreviewVideo } from '.'

const CoursePreviewVideo: FC = () => {
  const { course, loading } = useAppSelector((state) => state.course)

  if (!course?.teaser?.svid && !course?.coverImage?.fileHttpLink) {
    return null
  }

  return (
    <StyledCoursePreviewVideo>
      <Player
        svid={course?.teaser?.svid}
        thumbnail={course.coverImage.fileHttpLink}
        loading={loading}
        minimal
      />
    </StyledCoursePreviewVideo>
  )
}

export default CoursePreviewVideo
